<div style="width:100%; position:absolute; top:0px; height: 65px; ; left: 0px">
        <reportHeader></reportHeader>
</div>

<div *ngIf="isMyReports" style="height:100%; overflow:auto; background-color: #ffffff">
        <myReports [expandAllFolders]="expandAllFolders" (expandAllFolders)="expandAllFoldersClick($event)"></myReports>
</div>

<div *ngIf="isAllReports" style="height:100%; overflow:auto; background-color: #ffffff">
        <allReports></allReports>
</div>

<div>
        <!-- <reportFooter (expandAllFolders)="expandAllFoldersClick($event)" (showAllReportsComponent)="showAllReportsComponent()"></reportFooter> -->
        <reportFooter (expandAllFolders)="expandAllFoldersClick($event)" (refreshedReportFolders)="reportFoldersRefreshed($event)"></reportFooter>
</div>